import FlatButton from 'material-ui/FlatButton';
import {connect} from 'react-redux';
import {editUser} from '../actions/creators';
import {Map} from 'immutable';
import toastr from 'toastr';
import React, {PropTypes} from 'react';

function EditUserButton({handleClick}) {
  return <FlatButton primary onTouchTap={handleClick}>Edit</FlatButton>;
}

EditUserButton.propTypes = {
  handleClick: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  user: PropTypes.instanceOf(Map).isRequired
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    handleClick: () => dispatch(editUser(ownProps.user.get('id')))
      .catch(error => {
        toastr.error('An error occurred while attempting to edit the user.', 'Error');
        throw error;
      })
  };
}

export default connect(
  null,
  mapDispatchToProps
)(EditUserButton);



// WEBPACK FOOTER //
// ./app/features/users/containers/EditUserButton.js